import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import PropTypes from "prop-types";
import React, { useState } from "react";

import { joinClasses } from "@utils/materialUI";

const useStyles = makeStyles(() => ({
  item: {
    marginBottom: "4px",
  },
  itemToggle: {
    display: "flex",
    alignItems: "center",
    height: "44px",
    paddingLeft: "16px",
    paddingRight: "16px",
    borderRadius: "4px",
    textDecoration: "none",
    userSelect: "none",
    cursor: "pointer",
  },
  itemToggleIcon: {
    color: "#ffffff",
    fontSize: "0px",
  },
  itemToggleLabel: {
    display: "block",
    flex: 1,
    paddingLeft: "16px",
    color: "#ffffff",
  },
  itemToggleArrow: {
    fontSize: "0px",
    transition: "transform 0.2s ease-out",
  },
  itemToggleArrowActive: {
    transform: "rotate(90deg)",
  },
  itemToggleArrowIcon: {
    fontSize: "14px",
    color: "#ffffff",
  },
  itemToggleMenu: {
    maxHeight: "0px",
    overflow: "hidden",
    transition: "max-height 0.4s ease",
  },
  itemToggleMenuActive: {
    maxHeight: "1000px",
  },
}));

function SideMenuItemMenu(props) {
  const classes = useStyles();

  const [active, setActive] = useState(false);

  function handleToggleMenu() {
    setActive(!active);
  }

  function handleActiveChild() {
    setActive(true);
  }

  return (
    <div className={classes.item}>
      <React.Fragment>
        <div onClick={handleToggleMenu} className={classes.itemToggle}>
          <div className={classes.itemToggleIcon}>
            {React.createElement(props.icon, { fontSize: "small" })}
          </div>
          <Typography variant="body2" className={classes.itemToggleLabel}>
            {props.label}
          </Typography>
          <div
            className={joinClasses(classes.itemToggleArrow, {
              [classes.itemToggleArrowActive]: active,
            })}
          >
            <ArrowForwardIosIcon className={classes.itemToggleArrowIcon} />
          </div>
        </div>
        <div
          className={joinClasses(classes.itemToggleMenu, {
            [classes.itemToggleMenuActive]: active,
          })}
        >
          {React.Children.map(props.children, (element, i) => {
            return React.cloneElement(element, {
              key: `side-menu-item-1-${i}`,
              level: 2,
              onActive: handleActiveChild,
            });
          })}
        </div>
      </React.Fragment>
    </div>
  );
}

SideMenuItemMenu.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.any,
};

SideMenuItemMenu.defaultProps = {
  label: "",
  icon: null,
};

export default SideMenuItemMenu;
